import { render, staticRenderFns } from "./bnps_create_project.vue?vue&type=template&id=cdf6d0c4&"
import script from "./bnps_create_project.vue?vue&type=script&lang=js&"
export * from "./bnps_create_project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports